import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { BarclaycardGooglePayComponentDef } from '@df/module-barclaycard/google-pay/barclaycard-google-pay.component.def';
import { CheckoutFormComponent } from '../../../checkout/form/checkout-form.component';
import { CheckoutStepComponent } from '../../../checkout/step/checkout-step.component';
import { ResultComponent } from '../../../ui/api/result.component';

@Component({
    selector: 'barclaycard-google-pay',
    templateUrl: './barclaycard-google-pay.html',
    styleUrls: ['./barclaycard-google-pay.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ResultComponent]
})

export class BarclaycardGooglePayComponent extends BarclaycardGooglePayComponentDef{
    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        changeDetectorRef: ChangeDetectorRef,
        protected override scrollToService: ScrollToService,
        checkoutStepComponent: CheckoutStepComponent
    ) {
        super(checkoutFormComponent, changeDetectorRef, scrollToService, checkoutStepComponent);
    }


}